import styled from "@emotion/styled";

import { ResponsiveEChartsRenderer } from "metabase/visualizations/components/EChartsRenderer";

export const ChartRenderer = styled(ResponsiveEChartsRenderer)`
  height: 100%;
`;
